import {useTranslation} from "react-i18next";
import {NavLink} from "react-router-dom";

export const ProductSideMenu = ({product, selectedItem, onChange}) => {
    const { t } = useTranslation();
    return (
        <aside id="separator-sidebar" className="min-w-64 max-md:hidden" aria-label="Sidebar">
            <div className="h-full px-3">
                {product.groups.map((group, index) => (
                    <ul key={index} className={`flex flex-col space-y-1 text-secondary-color pb-8 
                                    ${index > 0 ? "border-t border-line-color pt-8" : ""}`}>
                        <p className="font-bold text-xl text-black text-start pb-2">{t(group.name)}</p>
                        {group.items.map((item) => (
                            <MenuItem key={item.id} product={product}
                                      item={item} selectedItem={selectedItem}
                                      onChange={onChange} />
                        ))}
                    </ul>
                ))}
            </div>
        </aside>
    )
}

export const MenuItem = ({product, item, selectedItem, onChange}) => {
    const { t } = useTranslation()
    let isSelected = item.id === selectedItem.id
    return (
        <li onClick={() => onChange(item)}>
            <NavLink to={`/product/${product.type}/${item.id}`} className={`flex items-center hover:bg-primary-light-color p-2 gap-3 
                            ${isSelected ? "bg-green" : "hover:bg-line-color"}`}>
                <img src={item.icon} className="w-8 aspect-square object-contain" alt=""/>
                <span>{t(item.title)}</span>
            </NavLink>
        </li>
    )
}
